import * as types from '../const/action.types';
import { get } from '../api/_basic';

export function loadVisibility(local, from) {
    return async (dispatch) => {
        dispatch(visibilitysHasErrored(false, ''));
        dispatch(visibilitysIsLoading(true));
        dispatch(loadVisibilitySuccess([]));
        return get(
            `${process.env.REACT_APP_API_LOCAL}/${local}/panelcontrol` +
                (from ? `?fecha=${from}` : ''),
        )
            .then((response) => {
                dispatch(visibilitysIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                const data = {
                    local,
                    from,
                    data: items,
                };
                dispatch(visibilitysHasErrored(false, ''));
                dispatch(loadVisibilitySuccess(data));
            })
            .catch((error) => {
                dispatch(visibilitysIsLoading(false));
                dispatch(visibilitysHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function loadVisibilitySuccess(data) {
    return {
        type: types.LOAD_VISIBILITY_SUCCESS,
        data,
    };
}

export function visibilitysHasErrored(bool, message) {
    return {
        type: types.VISIBILITY_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function visibilitysIsLoading(bool) {
    return {
        type: types.VISIBILITY_IS_LOADING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/visibility.actions.js